<template>
  <div :class="{ passive: !active }" :title="title" :data-title="title" class="stars">
    <span
      v-for="i in 5"
      :key="i"
      :class="{
        'glyphicon-star star c-orange': i <= stars,
        'glyphicon-star-empty star-empty c-gray': i > stars,
      }"
      class="glyphicon"
      aria-hidden="true"
    />
  </div>
</template>

<script>
export default {
  name: 'ProfileStarsVue',
  props: {
    stars: {
      type: Number,
      required: false,
      default: -1,
    },
    jobs: {
      type: Number,
      required: false,
      default: -1,
    },
    hasTitle: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
  },
  computed: {
    title() {
      if (this.hasTitle) {
        if (this.jobs >= 0 && this.stars >= 0) {
          return this.$tc(
            'The talent has received :stars stars in :jobs job | The talent has received :stars stars in :jobs jobs',
            this.jobs,
            {
              stars: this.stars,
              jobs: this.jobs,
            },
          )
        }
        return this.$t('Still no feedback')
      }
      return ''
    },
    active() {
      return this.stars >= 0
    },
  },
}
</script>

<style scoped></style>
